export const MEDICAL_CERTIFICATE_REASON_OPTIONS = {
  ORIENTED_TO_REST_TODAY: 'Foi orientado a permanecer em repouso hoje',
  ORIENTED_TO_REST_FOR_PERIOD: 'Deverá permanecer em repouso a partir de hoje por',
  MATERNITY_LEAVE: 'Iniciar licença maternidade, devendo ficar afastada por',
  ORIENTED_TO_RETURN: 'Foi orientado a retornar ao trabalho',
  IN_CONDITIONS: 'Se apresenta em condições físicas e mentais para exercer as atividades',
  NOT_IN_CONDITIONS: 'Não se apresenta em condições físicas e mentais para exercer as atividades',
  ABLE: 'Está apto a exercer práticas esportivas',
  NOT_ABLE: 'Não está apto a exercer práticas esportivas',
  OTHER: 'Outro',
};
